export enum SearchResultFields {
  Period = "period",
  Vintage = "vintage",
  PageCount = "pageCount",
}
